export const convertToCsv = (json: any) => {
  const items = json.map((item: any) => {
    return Object.values(item).map((value) => {
      if (typeof value === "string") {
        // Wrap values containing commas in double quotes
        return `"${value}"`
      }
      return value
    })
  })

  const header = Object.keys(json[0]).map((name) => `"${name}"`)
  const csv = [header.join(",")]
    .concat(items.map((row: any) => row.join(",")))
    .join("\n")
  return csv
}

export const downloadCsv = (jsonData: any, fileName: string) => {
  const csvData = convertToCsv(jsonData)
  const blob = new Blob([csvData], { type: "text/csv" })
  const link = document.createElement("a")
  link.href = window.URL.createObjectURL(blob)
  link.download = `${fileName}.csv`
  link.click()
}
